
  var _styles = {
  "flight-theme-4": {
    "position": "relative",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "width": "100%"
  },
  "flight-theme-4_flight-container": {
    "width": "4.64rem",
    "position": "relative",
    "display": "flex",
    "flexDirection": "column"
  },
  "flight-theme-4_flight-container_flight-card": {
    "width": "100%",
    "position": "relative",
    "background": "#fff",
    "display": "flex",
    "flexDirection": "column",
    "borderRadius": "0.34667rem",
    "paddingTop": "0.24rem",
    "paddingRight": "0.24rem",
    "paddingBottom": "0.26667rem",
    "paddingLeft": "0.24rem"
  },
  "flight-theme-4_flight-container_flight-card_flight-img": {
    "width": "4.16rem",
    "overflow": "hidden",
    "borderRadius": "0.16rem"
  },
  "flight-theme-4_flight-container_flight-card_label-word": {
    "borderRadius": "0.16rem 0 0.16rem 0",
    "fontSize": "0.26667rem",
    "fontFamily": "PingFangSC-Medium",
    "lineHeight": "0.4rem",
    "paddingTop": 0,
    "paddingRight": "0.13333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.13333rem",
    "position": "absolute",
    "top": "0.24rem",
    "left": "0.24rem"
  },
  "flight-theme-4_flight-container_flight-card_flight-city": {
    "position": "relative",
    "display": "flex",
    "width": "100%",
    "justifyContent": "space-between",
    "alignItems": "center",
    "flexDirection": "row"
  },
  "flight-theme-4_flight-container_flight-card_flight-city_flight-city-row": {
    "position": "relative",
    "display": "flex",
    "alignItems": "center",
    "flexDirection": "row",
    "fontSize": "0.37333rem",
    "lineHeight": "0.53333rem",
    "fontFamily": "PingFangSC-Regular",
    "color": "rgb(0,0,0)"
  },
  "flight-theme-4_flight-container_flight-card_flight-city_flight-city-name": {
    "fontSize": "0.37333rem"
  },
  "flight-theme-4_flight-container_flight-card_flight-city_flight-price": {
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.45333rem",
    "color": "rgb(255,94,26)",
    "lineHeight": "0.64rem"
  },
  "flight-theme-4_flight-container_flight-card_flight-city_flight-city-img": {
    "marginTop": 0,
    "marginRight": "0.08rem",
    "marginBottom": 0,
    "marginLeft": "0.08rem",
    "width": "0.4rem",
    "opacity": 0.42
  },
  "flight-theme-4_flight-container_flight-card_flight-city_flight-price-icon": {
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.32rem",
    "color": "rgb(255,94,26)",
    "lineHeight": "0.44rem"
  },
  "flight-theme-4_flight-container_flight-card_flight-city_flight-time": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgba(0,0,0,0.42)",
    "lineHeight": "0.44rem"
  },
  "flight-theme-4_flight-container_flight-card_flight-city_flight-discout": {
    "borderWidth": "1px",
    "borderStyle": "solid",
    "borderColor": "rgb(255,94,26)",
    "borderRadius": "6px",
    "paddingTop": 0,
    "paddingRight": "0.10667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.10667rem",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(255,94,26)",
    "letterSpacing": 0,
    "lineHeight": "0.4rem"
  }
};



  module.exports = _styles;
  